import React, {Component} from 'react';
import Loading from "../Common/Loading";
import Toast from "../Common/Toast";
import Actionbar from "../Common/Actionbar";
import API from "../../services/API";
import {toast} from "react-toastify";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {

    faCog,
    faFlagCheckered,

    faHashtag,
 faTruckMoving
} from "@fortawesome/free-solid-svg-icons";



const currencyFormat = Intl.NumberFormat('en-US');
class ReagentRequestProfile extends Component {
    state = {
        isLoaded:false,
        request : [],
        user : [],
        charge : 0

    }
    onInputChange = (event) => {

        this.setState({[event.target.name] : event.target.value});
    }

    onChargeClick = (is_charge) => {
        if(is_charge && this.state.charge < 1) {
            toast.error('لطفا مبلغ افزایش را درست وارد کنید');
            return false;
        }

        const request = {
            charge : is_charge ? this.state.charge : 0,
            decharge : 0 ,
            description : 'پورسانت مربوط انجام درخواست شرکت معرفی شده توسط شما '  + this.state.request.company ,
            id:this.state.user.id,
            reagent : 1,
            request_id: this.props.match.params.id
        }
        this.setState({isLoaded: false})
        API.charge(request)
            .then((response) => {
                API.getWalletDetaild(request)
                    .then((response) => {
                        this.setState(response.results)


                        setTimeout (() => {
                            window.location.assign("/reagent-requests/");
                        },400)

                    })

                setTimeout (() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                },400)

            })
            .catch((error) => {
                this.setState({isLoaded: true})
                toast.error(error.response.data.user_message);

            });
    }
    render() {
        return (
            <React.Fragment >
                {!this.state.isLoaded ? <Loading/> :''}
                <Toast/>
                <Actionbar noBack={0} title='پروفایل درخواست'/>
                <section className="container mt-4 rtl py-5 mb-5">
                    <div className="row px-2 border-bottom pb-2">
                        <div className="col-1 ">
                            <FontAwesomeIcon icon={faHashtag} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            کد پیگیری
                        </div>
                        <div className="col-7 text-left fw-bold text-primary">
                            {this.state.request.tracking_code}
                        </div>
                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faCog} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            وضعیت درخواست
                        </div>
                        <div className="col-7 text-left fw-bold super-small" >

                            {this.state.request.status}
                        </div>


                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faFlagCheckered} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            نام شرکت
                        </div>
                        <div className="col-7 text-left fw-bold super-small">
                            {this.state.request.company}
                        </div>
                    </div>

                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faTruckMoving} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            نام راننده
                        </div>
                        <div className="col-7 text-left fw-bold super-small">
                            {this.state.request.driver}
                        </div>
                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faTruckMoving} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            صافی راننده
                        </div>
                        <div className="col-7 text-left fw-bold super-small">
                            {currencyFormat.format(this.state.request.driver_share)}
                            &nbsp;
                            ریال
                        </div>
                    </div>

                    <div className="row mx-1 bg-secondary   mt-5 rounded bg-opacity-25" >
                        <div className="col-12 text-center py-2 fw-bold text-dark super-small-2 border-bottom border-light">
                            واریز پاداش برای معرف
                        </div>
                        <div className="col-12 text-center fw-bold py-2 text-primary">
                            نام معرف:
                            &nbsp;
                            {this.state.user.name}
                        </div>
                        <div className="col-12 mt-2 py-2">
                            <div className="form-floating  ">
                                <input type="tel" className="form-control w-100 text-center" id="floatingInput"
                                       name='charge'
                                       value={this.state.charge}
                                       onChange={this.onInputChange}
                                />
                                <label htmlFor="floatingInput" className='small'>مبلغ پاداش (ریال)</label>
                            </div>
                        </div>
                        <div className="col-12 mt-2 py-4">
                            <button className='btn btn-success w-100'
                                    onClick={() => {
                                        this.onChargeClick(1)
                                    }}
                            >
                                شارژ
                                &nbsp;
                                {currencyFormat.format(this.state.charge / 10)}
                                &nbsp;
                                تومان
                            </button>
                        </div>
                    </div>
                </section>

            </React.Fragment>
        );
    }
    componentDidMount() {
        const request = {
            id : this.props.match.params.id
        }
        API.reagentRequestsDetails(request)
            .then((response) => {
                const request = response.results;
                this.setState(request)
                this.setState({ isLoaded : true})
                setTimeout (() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                },400)
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });

    }
}

export default ReagentRequestProfile;